import React from 'react'

const useToggle = (initialState = false): [boolean, any] => {
  const [state, setState] = React.useState<boolean>(initialState)
  const toggle = React.useCallback((): void => setState((state) => !state), [])
  return [state, toggle]
}
export default useToggle
